import React, { useEffect, useState } from "react";
import "../gazetteFinder/GazetteFinder.css";
import { useNavigate } from "react-router-dom";
import api from "../../../services/baseUrl";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, CircularProgress, Tab } from "@mui/material";

export default function RequestList() {
  const navigate = useNavigate();
  const [searchResult, setSearchResult] = useState([]);
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState("1");

  useEffect(() => {
    setLoading(true);

    const fetchData = async () => {
      try {
        const response = await api.get("/ewarta/requests/get/admin");
        const sortedData = response.data.sort((a, b) => b.id - a.id); // sort by id descending
        setSearchResult(sortedData);
        setLoading(false);
      } catch (e) {}
    };

    fetchData();
  }, []);
  const handleSearch = (item) => {
    navigate(`${item.id}`, {
      state: { request: item },
    });
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const getCurrentData = () => {
    switch (value) {
      case "1":
        return searchResult.filter((item) => item.wartaDocumentId === null);

      case "2":
        return searchResult.filter(
          (item) => item.wartaDocumentId !== null && item.status === 0
        );

      case "3":
        return searchResult.filter(
          (item) => item.status === 1 && item.refNo !== null
        );

      default:
        return [];
    }
  };

  return (
    <div className="wartaState-container">
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList onChange={handleChange} aria-label="index data tabs">
            <Tab label="New Requests" value="1" />
            <Tab label="Completed Requests" value="2" />
            <Tab label="Purchased Requests" value="3" />
          </TabList>
        </Box>
        <TabPanel value={value}>
          {loading ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <CircularProgress />
              <span>Retrieving all titles...</span>
            </div>
          ) : (
            <div className="ewarta-search-result-container">
              <div className="ewarta-search-result-body">
                <table>
                  <thead>
                    <tr>
                      <td>Request Date/Time</td>
                      <td>Username</td>
                      <td>Query</td>
                      {value !== "3" && <td>Action</td>}
                    </tr>
                  </thead>
                  <tbody>
                    {getCurrentData().map((item) => {
                      const queryParts = item.query.split(" | ");

                      const isSingleValue = queryParts.every(
                        (part) => !part.includes(":")
                      );
                      return (
                        <tr key={item.id}>
                          <td>
                            {new Date(item.dateCreated).toLocaleDateString(
                              "en-GB",
                              {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                              }
                            )}
                          </td>
                          <td style={{ textAlign: "left" }}>
                            Username: {item.userId?.username} <br />
                            Email: {item.userId?.email} <br />
                            Contact No: {item.userId?.contactNumber}
                          </td>
                          <td>
                            {isSingleValue ? (
                              // If it's just a single value, display as one <li>
                              <ul style={{ padding: 0, listStyleType: "none" }}>
                                <li>{item.query}</li>
                              </ul>
                            ) : (
                              // If there are key-value pairs, display as an ordered list
                              <ul style={{ padding: 0, listStyleType: "none" }}>
                                {queryParts.map((part, index) => {
                                  const [key, value] = part.split(": ");

                                  // Function to convert camelCase to Title Case
                                  const formatKey = (key) => {
                                    return key
                                      .replace(/([A-Z])/g, " $1") // insert space before capital letters
                                      .replace(/^./, (str) =>
                                        str.toUpperCase()
                                      ); // capitalize first letter
                                  };

                                  return (
                                    <li key={index}>
                                      <strong>
                                        {key ? formatKey(key) : ""}:
                                      </strong>{" "}
                                      {value}
                                    </li>
                                  );
                                })}
                              </ul>
                            )}
                          </td>
                          {value !== "3" && (
                            <td
                              style={{
                                textAlign: "center",
                              }}
                            >
                              <button
                                onClick={() => handleSearch(item)}
                                style={{
                                  backgroundColor: "#0078ff",
                                  color: "white",
                                  border: "none",
                                  padding: "5px 10px",
                                  cursor: "pointer",
                                  borderRadius: "4px",
                                }}
                              >
                                Search
                              </button>
                            </td>
                          )}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                <div style={{ height: "30px" }}></div>
              </div>
            </div>
          )}
        </TabPanel>
      </TabContext>
    </div>
  );
}
